// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__fX_TH","title":"ClientInsurance_title__2fi0Y","itemText":"ClientInsurance_itemText__133u6"};